import React, { useState } from 'react';
import { Coins } from 'lucide-react';
import StoreModal from './StoreModal';

const WalletButton = ({ balance }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gradient-to-r from-amber-400 to-amber-600 hover:from-amber-300 hover:to-amber-500 text-slate-950 font-black text-sm shadow-lg shadow-amber-500/20"
        title="Comprar ProCoins"
        data-testid="wallet-btn"
      >
        <Coins className="w-4 h-4" />
        <span className="tabular-nums">{Number(balance || 0).toLocaleString('pt-PT')}</span>
        <span className="hidden sm:inline">PC</span>
      </button>
      {open && <StoreModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default WalletButton;
